import { render, staticRenderFns } from "./PublicationDatePicker.vue?vue&type=template&id=7920bab6&scoped=true&"
import script from "./PublicationDatePicker.vue?vue&type=script&lang=js&"
export * from "./PublicationDatePicker.vue?vue&type=script&lang=js&"
import style0 from "./PublicationDatePicker.vue?vue&type=style&index=0&id=7920bab6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7920bab6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTimePicker } from 'vuetify/lib/components/VTimePicker';
installComponents(component, {VBtn,VDatePicker,VMenu,VRadio,VRadioGroup,VSpacer,VTextField,VTimePicker})
